import * as React from 'react';
import { RgbaStringColorPicker, HexColorInput } from 'react-colorful';
import { Translate } from 'react-redux-i18n';

import { Overlay, ControlsWrapper, InputWrapper, ButtonsWrapper, Button, Sign } from './styles';
import { hexToRgba, rgbaToHexAndAlpha } from '../../../../../utils/style';

interface ColorPickerProps {
	initialColor: string; // rgba()
	onConfirm: (color: string) => void;
	onCancel: () => void;
}

const ColorPicker = ({ initialColor, onConfirm, onCancel }: ColorPickerProps) => {
	const [color, setColor] = React.useState(initialColor);

	const handleConfirmClick = () => {
		onConfirm(color);
	};

	const handleHexColorInputChange = (hexColor: string) => {
		// ignore invalid hex values
		if (hexColor.length < 7) {
			return;
		}

		const { alpha } = rgbaToHexAndAlpha(color);
		const rgbaColor = hexToRgba(hexColor, alpha * 100);
		setColor(rgbaColor);
	};

	const handleOpacityInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;

		if (isNaN(+value) || +value < 0 || +value > 100) {
			return;
		}

		const { hexColor } = rgbaToHexAndAlpha(color);
		const rgbaColor = hexToRgba(hexColor, +value);
		setColor(rgbaColor);
	};

	const { hexColor, alpha } = rgbaToHexAndAlpha(color);

	return (
		<Overlay>
			<ButtonsWrapper>
				<Button onClick={onCancel}>
					<Translate value="messages.cancel" />
				</Button>
				<Button onClick={handleConfirmClick}>
					<Translate value="messages.ok" />
				</Button>
			</ButtonsWrapper>
			<ControlsWrapper>
				<RgbaStringColorPicker
					color={color}
					onChange={setColor}
				/>
				<div>
					<InputWrapper>
						<Sign>#</Sign>
						<HexColorInput
							color={hexColor}
							onChange={handleHexColorInputChange}
						/>
					</InputWrapper>
					<InputWrapper isOpacity={true}>
						<input
							type="text"
							value={Math.round(alpha * 100)}
							onChange={handleOpacityInputChange}
						/>
						<Sign>%</Sign>
					</InputWrapper>
				</div>
			</ControlsWrapper>
		</Overlay>
	);
};

export default ColorPicker;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ThemesPanel/ColorPicker/index.tsx